import React from 'react';
import { Route } from 'react-router-dom';
import Layout from '../../../Layout/index';
import Commerce from './Commerce';
import Finance from './Finance';
import OnLineMarketingDashboard from '../../../Dashboards/OnLineMarketing/index';
import AppDashboard from '../../../Dashboards/App/index';
import BookingDashboard from '../../../Dashboards/Booking/index';
import FitnessDashboard from '../../../Dashboards/Fitness/index';
import UI from './UI';
import Mail from '../../../Mail/index';
import Chat from '../../../Chat/index';
import Todo from '../../../Todo/index';
import Forms from './Forms';
import Tables from './Tables';
import Charts from './Charts';
import Maps from './Maps';
import Account from './Account';
import ECommerce from './ECommerce';
import DefaultPages from './DefaultPages';
import Documentation from './Documentation';
import AllEnquiries from '../../../TranAdmin/AllEnquiries';
import Consignee from '../../../TranAdmin/Consignee';
import Consignor from '../../../TranAdmin/Consignor';
import Transporter from '../../../TranAdmin/Transporter';
import TransporterRoutes from '../../../TranAdmin/Transporter/TransporterRoutes';
import SingleEnquiry from '../../../TranAdmin/AllEnquiries/SingleEnquiry';
import Bids from '../../../TranAdmin/AllEnquiries/Bids';
import Shipments from '../../../TranAdmin/AllEnquiries/Shipments';


export default () => (
  <div>
    <Layout />
    <div className="container__wrap">
      {/* <Route path="/e_commerce_dashboard" component={Commerce} />
      <Route path="/online_marketing_dashboard" component={OnLineMarketingDashboard} />
      <Route exact path="/app_dashboard" component={AppDashboard} /> */}

      <Route path="/booking_dashboard" component={BookingDashboard} />
      <Route exact path="/all_enquiries" component={AllEnquiries} />
      <Route exact path="/all_enquiries/enquiry/:id" component={SingleEnquiry} />
      <Route exact path="/bids/:id" component={Bids} />
      <Route exact path="/shipments/:id" component={Shipments} />
      <Route path="/consignor" component={Consignor} />
      <Route path="/consignee" component={Consignee} />
      <Route exact path="/transporter" component={Transporter} />
      <Route exact path="/transporter/routes/:id" component={TransporterRoutes} />
      {/* <Route path="/finance_dashboard" component={Finance} />
      <Route path="/fitness_dashboard" component={FitnessDashboard} />
      <Route path="/ui" component={UI} />
      <Route path="/mail" component={Mail} />
      <Route path="/chat" component={Chat} />
      <Route path="/todo" component={Todo} />
      <Route path="/forms" component={Forms} />
      <Route path="/tables" component={Tables} />
      <Route path="/charts" component={Charts} />
      <Route path="/maps" component={Maps} />
      <Route path="/account" component={Account} />
      <Route path="/e-commerce" component={ECommerce} />
      <Route path="/default_pages" component={DefaultPages} />
      <Route path="/documentation" component={Documentation} /> */}
    </div>
  </div>
);
